/**
 * MarketingNavbar - Navigation for the marketing site (www.domain.com)
 * Used for public pages like homepage, about, services, contact
 */
import { Navbar } from './Navbar';

export const MarketingNavbar = () => {
  return <Navbar />;
};
